import React, { useState } from 'react';

import 'react-datepicker/dist/react-datepicker.css';
import  './Alcance.css';
import ErrorBoundary from '../components/ErrorBoundary.js';

import { MedirTransporteTerrestre } from '../components/MedirTransporteTerrestre';
import { MedirTransporteAereo } from '../components/MedirTransporteAereo';
import { MedirTransporteMaritimo } from '../components/MedirTransporteMaritimo';
import { MedirEnergiaElectrica } from '../components/MedirEnergiaElectrica';

import { MedirReduccion } from '../components/MedirReduccion';


function Alcance1( props ) {
  //const location = useLocation();
  //const { cat } = location.state;
  const cat = props.sub;
  console.log('##### state cat.id:: '+cat.id);
  console.log('state cat.nombre:: '+cat.nombre);
  //console.log('props cat.nombre:: '+props.nombre);
  
  //const [status, setStatus] = useState(400);

  
  /*const [user, loading, error] = useState(auth);
  const [nombreEntrada, setNombreEntrada] = useState('');
  const [startDate, setStartDate] = useState(new Date());
  const [value, setValue] = useState('');
  const [origen, setOrigen] = useState('');
  const [destino, setDestino] = useState('');
  const [kilometros, setKilometros] = useState('');
  const [tipoVehiculo, setTipoVehiculo] = useState('');
  const [marcaReferencia, setMarcaReferencia] = useState('');
  const [combustible, setCombustible] = useState('');
  const [peso, setPeso] = useState(0);
  const [alcance, setAlcance] = useState(1);
  const [subcat, setSubcat] = React.useState([]);
  const [subs, setSubs]     = React.useState([]);
  const [tipoTransporteAereo, setTipoTransporteAereo] = React.useState('');
  const [tipoViajeAereo, setTipoViajeAereo] = React.useState('Directo');
  const [claseVuelo, setClaseVuelo] = React.useState('Economico');
  const [tipoEmbarcacion, setTipoEmbarcacion] = React.useState('');
  const [unidadesTransportadas, setUnidadesTransportadas] = React.useState('');
  const [horasDia, setHorasDia] = React.useState(0);
  const [diasMes, setDiasMes] = React.useState(0);
  const [nombreDispositivo, setNombreDispositivo] = React.useState('');
  const [cantidadDispositivos, setCantidadDispositivos] = React.useState(0);
  const [consumoEnergiaAnual, setConsumoEnergiaAnual] = React.useState(0);
  const [marcaReferenciaDispositivo, setMarcaReferenciaDispositivo] = React.useState('');
  const [unidadConsumoEnergia, setUnidadConsumoEnergia] = React.useState('');
  const [potenciaDispositivo, setPotenciaDispositivo] = React.useState(0);
  const [unidadPotencia, setUnidadPotencia] = React.useState('');

  const handleUnidadPotencia = (event) => {
    setUnidadPotencia(event.target.value);
    console.log('unidadPotencia: '+unidadPotencia);
  }
  const handlePotenciaDispositivo = (event) => {
    setPotenciaDispositivo(event.target.value);
    console.log('potenciaDispositivo: '+potenciaDispositivo);
  }
  const handleUnidadConsumoEnergia = (event) => {
    setUnidadConsumoEnergia(event.target.value);
    console.log('unidadConsumoEnergia: '+unidadConsumoEnergia);
  }

  const handleMarcaReferenciaDispositivo = (event) => {
    setMarcaReferenciaDispositivo(event.target.value);
    console.log('marcaReferenciaDispositivo: '+marcaReferenciaDispositivo);
  }
  const handleConsumoEnergiaAnual = (event) => {
    setConsumoEnergiaAnual(event.target.value);
    console.log('consumoEnergiaAnual: '+consumoEnergiaAnual);
  }
  const handleCantidadDispositivos = (event) => {
    setCantidadDispositivos(event.target.value);
    console.log('cantidadDispositivos: '+cantidadDispositivos);
  }
  const handleNombreDispositivo = (event) => {
    setNombreDispositivo(event.target.value);
    console.log('nombreDispositivo: '+nombreDispositivo);
  }

  const handleValue = () => setValue('');

  const handleNombreEntrada = (event) => {
    console.log('NombreEntrada: '+event.target.value);
    setNombreEntrada(event.target.value);
    console.log('NombreEntrada: '+nombreEntrada);
  }
  const handleOrigen = (event) => {
    console.log('Origen: '+event.target.value);
    setOrigen(event.target.value);
  }
  const handleDestino = (event) => {
    console.log('Destino: '+destino);
    setDestino(event.target.value);
  }
  const handleKilometros = (event) => {
    console.log('kilometros: '+kilometros);
    setKilometros(event.target.value);
  }
  const handleTipoVehiculo = (event) => {
    console.log('tipoVehiculo: '+tipoVehiculo);
    setTipoVehiculo(event.target.value);
  }
  const handleMarcaReferencia = (event) => {
    console.log('marcaReferencia: '+marcaReferencia);
    setMarcaReferencia(event.target.value);
  }
  const handleCombustible = (event) => {
    console.log('combustible: '+combustible);
    setCombustible(event.target.value);
  }
  const handlePeso = (event) => {
    console.log('cPeso: '+peso);
    setPeso(event.target.value);
  }
  const handleTipoEmbarcacion = (event) => {
    console.log('TipoEmbarcacion: '+peso);
    setTipoEmbarcacion(event.target.value);
  }
  const handleUnidadesTransportadas = (event) => {
    console.log('UNidadesTrasnportadas: '+peso);
    setUnidadesTransportadas(event.target.value);
  }
  const handleHorasDia = (event) => {
    console.log('UHoras dia: '+horasDia);
    setHorasDia(event.target.value);
  }
  const handleDiasMes = (event) => {
    console.log('Udias mes: '+diasMes);
    setDiasMes(event.target.value);
  }
  const onChange = (event) => {
    setAlcance(event.target.value);
    console.log('Alcance: '+event.target.value);
  }
  React.useEffect(() => {
    getData();
    if (cat.nombre.includes('energía')) {
      document.getElementById('inputsBase').style.display = 'none';
    }else{
      document.getElementById('inputsBase').style.display = 'block';
    }
  }, []);
  const getData = () => {
    fetch("https://api.carbonbox.app/measure-transportes/62642045f4ba384208bdf1f4")
      .then(res => res.json())
      .then(
        (result) => {
          let nombreSubcatSel = cat.nombre.split(' ');
          nombreSubcatSel[1] = nombreSubcatSel[1].replace('é','e');
          nombreSubcatSel[1] = nombreSubcatSel[1].replace('í','i');
          //console.log('nombreSubcatSel:: '+nombreSubcatSel[1]);
          let nuevosSubs = [];
          for (const [key, value] of Object.entries(result)) {
              let nombreSubcatMeasure = key.split('_');
              //console.log('nombreSubcatMeasure:: '+nombreSubcatMeasure[0]);
              if (nombreSubcatSel[1] === nombreSubcatMeasure[0]) {
                nuevosSubs.push({
                  nombre: nombreSubcatMeasure[1] +' '+ nombreSubcatMeasure[2],
                  id: key
                })
              }
          }
          setSubs(nuevosSubs);
        },
        (error) => {
          console.log('Error trayendo los datos');
        }
      )
  }
  


  const onSubmit = async (event) => {
    event.preventDefault();
    
    /*const headers = new Headers();
    headers.append('Authorization', 'Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6IjYyNWY3MjdmZTU3MTU1MTBiY2RkNWIxMiIsImlhdCI6MTY1MTcwMTkyOCwiZXhwIjoxNjU0MjkzOTI4fQ.uCdUu5Kn9lYGC0gKY6AkjMiKGqNb-JgoUesrtozYuSE');
    headers.append('Content-Type','application/json; charset=UTF-8');
    let resultFetch = await fetch('https://api.carbonbox.app/measure-transportes',{
      body: JSON.stringify(datosPOST),
      headers: headers,
      method: 'POST',
      timeout: 30000 
    } )
    .then( result => {
      //status === '200' ? setStatus(true) : setStatus(false);
      setStatus(result.status) ;
      console.log('status del result '+status);
    })
    .catch ( err => {
      console.log("Error del fetch"+err)
    });
    setOpenModal(true);
  }
  /*const onChangeInput = (event) => {
    console.log('event'+event.target.nombre);
    const values = [...subs];
    values.push({
      nombre:"",
      id: "",
    })
    setSubs(values);
  }*/
  /*const renderInputs = subs.map((s, index) => {
    //console.log('renderInputs:: '+s.nombre);index++;
    return (
      <InputSubcat className={"form-control"} key={s.id} value={s.nombre} onChange={ (event) => onChangeInput(index, event)} nombre={s.nombre} placeholder={s.nombre}></InputSubcat>
    );
  });*/

  /*async function onChangeTipoTransporte (event) {
    console.log('onChangeTipoTransporte:: '+event.target.value);
    setTipoTransporteAereo(event.target.value);
    
    if (tipoTransporteAereo === "Carga") {
      document.getElementById('claseVuelo').style.display = 'block';
    }else{
      document.getElementById('claseVuelo').style.display = 'none';
    }
  }

  const onChangeTipoViaje = (event) => {
    console.log('onChangeTipoViaje:: '+event.target.value);
    setTipoViajeAereo(event.target.value)
  }
  const onChangeClaseVuelo = (event) => {
    console.log('onChangeClaseVuelo:: '+event.target.value);
    setClaseVuelo(event.target.value)
  }*/
  const onSubmit1 = async () => {
    console.log('####### ############# ######### onChangeTipoTransporte:: ');
    console.log('####### ############# ######### onChangeNombreEntrada:: ');
    //setOpenModal(true);
   
  }

  const renderSubcategoria = () => {
    if (cat.nombre === "Transporte terrestre") {
      return <MedirTransporteTerrestre sub={cat}></MedirTransporteTerrestre>
    }else if (cat.nombre === "Transporte aéreo") {
      return <MedirTransporteAereo sub={cat}></MedirTransporteAereo>
    }else if (cat.nombre === "Transporte marítima") {
      return <MedirTransporteMaritimo sub={cat}></MedirTransporteMaritimo>
    }else if (cat.nombre === "Consumo de energía eléctrica") {
      return <MedirEnergiaElectrica sub={cat}></MedirEnergiaElectrica>
    }else if (cat.nombre === "Reducción huella de CO2") {
      return <MedirReduccion sub={cat}></MedirReduccion>
    }
  } 
  
  return (
    <>
    <div style={{ padding:'0px'  }} className='bg_div'>
      <h1>Subcategoría {cat.nombre}</h1>
      <button onClick={onSubmit1} className="btn btn-primary btn-block">test Enviar</button>
      <ErrorBoundary>
      <div style={{ padding:'30px' }}>
      
      {renderSubcategoria()}

      {/*!!openModal && (
        <Modal>
          <span> { status === 200
                ? <h3>Registro ingresado con éxito!</h3>
                : <h3>Por favor verifique los datos ingresados!</h3>
          } </span>
          <button onClick={onClickModal}>Cerrar</button>
        </Modal>
      )*/}

      </div>
      <div>

      </div>
      </ErrorBoundary>
    </div>
    </>
  )}

export {Alcance1};



/*
    <>
    <div style={{ padding:'0px'  }} className='bg_div'>
      <h1>Subcategoría {cat.nombre}</h1>
      <button onClick={onSubmit1} className="btn btn-primary btn-block">test Enviar</button>
      <ErrorBoundary>
      <div style={{ padding:'30px' }}>
      <form onSubmit={onSubmit}>
        { renderTipoTransporte() }
      
        <div className="form-group">
            <label>Nombre</label>
            <input type="text" className="form-control" value={nombreEntrada} onChange={handleNombreEntrada} placeholder="Nombre personalizado de la entrada" />
        </div>
        
        <div className='form-group'>
          <label>Alcance</label>
          <Alcance value={value} onChange={onChange}></Alcance>
        </div>
        <div id='inputsBase'>
          <div className="form-group" >
              <label>Fecha</label>
              <DatePicker className='datePicker__input' 
                selected={startDate}
                onChange={(date) => setStartDate(date)} 
              />
              <label>Este es un viaje periódico</label>
          </div>
          <div className="form-group">
              <label>Origen</label>
              <input type="text" className="form-control" value={origen} onChange={handleOrigen} placeholder="Origen" />
          </div>
          <div className="form-group">
              <label>Destino</label>
              <input type="text" className="form-control" value={destino} onChange={handleDestino} placeholder="Destino" />
          </div>
          <div className="form-group">
              <label>Distancia (km)</label>
              <input type="text" className="form-control" value={kilometros} onChange={handleKilometros} placeholder="Distancia en km" style={{ width:'25%'}}/>
          </div>
          <div className="form-group">
              <label>Referencia o tipo producto</label>
              <input type="text" className="form-control" value={marcaReferencia} onChange={handleMarcaReferencia} placeholder="Marca o referencia vehículo" />
          </div>
          <div className="form-group">
              <label>Peso (Toneladas)</label>
              <input type="text" className="form-control" value={peso} onChange={handlePeso} placeholder="Peso en toneladas" style={{ width:'25%'}}/>
          </div>
        </div>
        
          { renderTipoViaje() }
          
          { renderClaseVuelo() }

          { renderTerrestre() }

          { renderMaritimo() }

          { renderEnergia() }
        
        <br/>
        <button type="submit" className="btn btn-primary btn-block">Agregar otra entrada</button>
      </form>

      {!!openModal && (
        <Modal>
          <span> { status === 200
                ? <h3>Registro ingresado con éxito!</h3>
                : <h3>Por favor verifique los datos ingresados!</h3>
          } </span>
          <button onClick={onClickModal}>Cerrar</button>
        </Modal>
      )}

      </div>
      <div>

      </div>
      </ErrorBoundary>
    </div>
    </>
*/



/*
function renderTipoTransporte() {
    if (cat.nombre.includes('aéreo')) {
      return <div className="form-group" onChange={onChangeTipoTransporte}>
                  <label style={{marginTop:'10px'}}>Tipo de transporte </label>
                  <br/>
                  <label > 
                  <input style={{marginLeft:'15px',accentColor:'green'}} defaultChecked type='radio' value='Carga'  name='tipoTransporte' ></input>
                  <label style={{marginLeft:'15px'}}>
                    <HiIcons.HiOutlineBookmarkAlt style={{color:'#1010C5'}}/>
                    <label>Carga</label>
                  </label>
                  </label>
                  <label >
                    <input style={{marginLeft:'15px',accentColor:'green'}} type='radio' value='Pasajeros' name='tipoTransporte' ></input>
                    <label style={{marginLeft:'15px'}}>
                      <BsIcons.BsPerson style={{color:'#1010C5'}}/>
                      Pasajeros
                    </label>
                  </label>
              </div>
    }else{
      return null;
    }
  }

  function renderTipoViaje() {
    if (cat.nombre.includes('aéreo')) {
    return <div className="form-group">
        <label style={{marginTop:'10px'}}>Tipo de viaje </label>
            <br/>
            <label >
            <input style={{marginLeft:'15px',accentColor:'green'}} defaultChecked type='radio' value='Directo'  onChange={onChangeTipoViaje} name='tipoViaje' ></input>
              <label style={{marginLeft:'15px'}}>
                <FaIcons.FaPlaneArrival style={{color:'#1010C5'}}/>
                Directo  
                <span className='checkmark'></span>
              </label>
            </label>
            <label >
              <input style={{marginLeft:'15px',accentColor:'green'}} type='radio' value='Escalas' onChange={onChangeTipoViaje} name='tipoViaje' ></input>
              <label style={{marginLeft:'15px'}}>
                <FaIcons.FaPlaneArrival style={{color:'#1010C5'}}/>
                Con escalas
                <span className='checkmark'></span>
              </label>
            </label>
        </div>
    }else{
      return null
    }
  }
  
  function renderClaseVuelo() {
    if (cat.nombre.includes('aéreo')) {
    return <div className="form-group" id='claseVuelo'> 
        <label style={{marginTop:'10px'}}>Clase de vuelo </label>
            <br/>
            <label >
            <input style={{marginLeft:'15px',accentColor:'green'}} defaultChecked type='radio' value='Economico'  onChange={onChangeClaseVuelo} name='claseVuelo' ></input>
              <label style={{marginLeft:'15px'}}>
                <FaIcons.FaRegMoneyBillAlt style={{color:'#1010C5',marginLeft:'5px'}}/>
                Económico
              </label>
              <span className='checkmark'></span>
            </label>
            <label >
              <input style={{marginLeft:'15px',accentColor:'green'}} type='radio' value='Ejecutivo' onChange={onChangeClaseVuelo} name='claseVuelo' ></input>
              <label style={{marginLeft:'15px'}}>
                <FaIcons.FaRegMoneyBillAlt style={{color:'#1010C5',marginLeft:'5px'}}/>
                Ejecutivo
                <span className='checkmark'></span>
              </label>
            </label>
            <label >
              <input style={{marginLeft:'15px',accentColor:'green'}} type='radio' value='Primera' onChange={onChangeClaseVuelo} name='claseVuelo' ></input>
              <label style={{marginLeft:'15px'}}>
                <FaIcons.FaRegMoneyBillAlt style={{color:'#1010C5',marginLeft:'5px'}}/>
                Primera
                <span className='checkmark'></span>
              </label>
            </label>
        </div>
    }else{
      return null
    }
  }

  function renderTerrestre() {
    if (cat.nombre.includes('terrestre')) {
    return <div>
        <label style={{marginTop:'10px'}}>Clase de vuelo </label>
            <br/>
            <div className="form-group">
          <label>Marca o referencia</label>
          <input type="text" className="form-control" value={marcaReferencia} onChange={handleMarcaReferencia} placeholder="Marca o referencia del producto" />
      </div>
      <div className="form-group">
          <label>Tipo vehículo</label>
          <input type="text" className="form-control" value={tipoVehiculo} onChange={handleTipoVehiculo} placeholder="Tipo vehículo" />
      </div>
      <div className="form-group">
          <label>Tipo combustible</label>
          <input type="text" className="form-control" value={combustible} onChange={handleCombustible} placeholder="Tipo combustible" />
      </div>
    </div>
    }else{
      return null
    }
  }

  function renderMaritimo() {
    if (cat.nombre.includes('marítima')) {
    return <div>
              <label style={{marginTop:'10px'}}>Clase de vuelo </label>
                  <br/>
                  <div className="form-group">
                <label>Tipo de embarcación</label>
                <input type="text" className="form-control" value={tipoEmbarcacion} onChange={handleTipoEmbarcacion} placeholder="Tipo de embarcación" />
            </div>
            <div className="form-group">
                <label>Unidades transportadas</label>
                <input type="text" className="form-control" value={unidadesTransportadas} onChange={handleUnidadesTransportadas} placeholder="Unidades transportadas" />
            </div>
          </div>
    }else{
      return null
    }
  }

  const renderEnergia = () => {
    console.log('energia '+cat.nombre);
    if (cat.nombre.includes('energía')) {
      
    return <div>
              <div className="form-group">
                <label>Nombre del dispositivo o máquina</label>
                <input type="text" className="form-control" value={nombreDispositivo} onChange={handleNombreDispositivo} placeholder="Nombre dispositivo o máquina" />
              </div>
              <div className="form-group">
                  <label>Cantidad dispositivos</label>
                  <input type="text" className="form-control" value={cantidadDispositivos} onChange={handleCantidadDispositivos} placeholder="Cantidad dispositivos" />
              </div>
              <div className="form-group">
                  <label>Marca o referencia</label>
                  <input type="text" className="form-control" value={marcaReferenciaDispositivo} onChange={handleMarcaReferenciaDispositivo} placeholder="Marca o referencia dispositivo" />
              </div>

              <div className="form-group">
                  <label>Consumo energía anual</label>
                  <input type="text" className="form-control" value={consumoEnergiaAnual} onChange={handleConsumoEnergiaAnual} placeholder="Consumo" />
              </div>
              <div className="form-group">
                  <label>Unidad
                  <select value={unidadConsumoEnergia} onChange={handleUnidadConsumoEnergia}>
                    <option value="kWh">kWh</option>
                    <option value="MWh">MWh</option>
                  </select>
                  </label>
              </div>
              <div className="form-group">
                  <label>Potencia dispositivo</label>
                  <input type="text" className="form-control" value={potenciaDispositivo} onChange={handlePotenciaDispositivo} placeholder="Potencia" />
              </div>
              <div className="form-group">
                <label>Unidad potencia
                <select value={unidadPotencia} onChange={handleUnidadPotencia}>
                  <option value="W">W</option>
                  <option value="kW">kW</option>
                  <option value="MW">MW</option>
                </select>
                </label>
              </div>
              
              <div className="form-group">
                <label>Horas uso día</label><br/>
                <input style={{ width:'100%'}} className="slider" type="range" min="0" max="24" step="1"  value={horasDia} onChange={handleHorasDia} />
                <div style={{ width:'100%'}}>
                  <label style={{position:'relative',top:'-47px',width:'18px',textAlign:'center',background:'gray',borderRadius:'15px',left:`calc(${ Number( (horasDia - 0) * 100 / (24 - 0) ) }% - (${ (horasDia / 2)}px))` }}>{horasDia}</label>
                  </div>
              </div>
              <div className="form-group">
                <label>Días uso mes</label><br/>
                <input style={{ width:'100%'}} className="slider" type="range" min="0" max="31" step="1"  value={diasMes} onChange={handleDiasMes} />
                <div style={{ width:'100%'}}>
                  <label style={{position:'relative',top:'-47px',width:'18px',textAlign:'center',background:'gray',borderRadius:'15px',left:`calc(${ Number( (diasMes - 0) * 100 / (31 - 0) ) }% - (${ (diasMes / 2)}px))` }}>{diasMes}</label>
                  </div>
              </div>
            </div>
    }else{
      return null
    }
  }
*/